import Tracker from './Tracker';

const globalTracker = new Tracker();

export default globalTracker;
